import { useEffect, useState } from "react";
import axios from "axios";

const API = "/api";

/** U1 F11 — the website reads the CANONICAL backend sticker catalog.
 *
 *  `src/data/stickerTemplates.js` is no longer a runtime source of templates:
 *  it only keeps the rendering palettes/helpers. Server-side rendering remains
 *  canonical, so this hook only provides the schema-controlled definitions the
 *  selector needs — exactly the same payload the mobile apps will consume.
 */
export const useStickerCatalog = () => {
  const [state, setState] = useState({
    loading: true, categories: [], templates: [], source: null, error: null,
  });

  useEffect(() => {
    let alive = true;
    (async () => {
      try {
        const [catRes, tplRes] = await Promise.all([
          axios.get(`${API}/stickers/categories`),
          axios.get(`${API}/stickers/templates`),
        ]);
        if (!alive) return;
        setState({
          loading: false,
          categories: catRes.data.categories || [],
          templates: tplRes.data.templates || [],
          source: tplRes.data.source || null,
          error: null,
        });
      } catch (e) {
        if (!alive) return;
        setState({ loading: false, categories: [], templates: [], source: null, error: e });
      }
    })();
    return () => { alive = false; };
  }, []);

  const templatesByCategory = (categoryId) =>
    state.templates.filter((t) => t.category === categoryId);

  const templateById = (templateId) =>
    state.templates.find((t) => t.id === templateId) || null;

  return { ...state, templatesByCategory, templateById };
};

export default useStickerCatalog;
